import {useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {setModalAlert} from '../../reducers/app/actions';
import Selector from '../../selectors/modals/alert';
import CashAppAlert from './cashapp-alert';
import ZelleAlert from './zelle-alert';
import VenmoAlert from './venmo-alert';
import CashtagNotFound from './cashtag-notfound';


export default () => {
    const dispatch = useDispatch(),
          {alert} = useSelector(Selector),
          [close, setClose] = useState(false);
    
    const blur = useRef(),
          modal = useRef();

    const closeHandler = () => {
        if(close)
            return;

        setClose(true);

        if(blur.current) {
            blur.current.classList.remove('animate__animated');
            blur.current.classList.remove('animate__fadeIn');
            blur.current.classList.add('animate__fadeOut');
            blur.current.classList.add('animate__animated');
        }

        if(modal.current) {
            modal.current.classList.remove('animate__animated');
            modal.current.classList.remove(alert.type === "danger" ? 'animate__bounceIn' : "animate__zoomIn");
            modal.current.classList.add(alert.type === "danger" ? 'animate__bounceOut' : "animate__zoomOut");
            modal.current.classList.add('animate__animated');
        }

        setTimeout(() => {
            dispatch(setModalAlert(null));
            setClose(false);
        }, 600);
    }

    if(!alert)
        return <></>;

    if(alert.cashapp_tech)
        return <CashAppAlert />

    if(alert.zelle)
        return <ZelleAlert />

    if(alert.venmo)
        return <VenmoAlert />

    if(alert.cashtag_notfound)
        return <CashtagNotFound />

    return (
        <>
            <div className="blur animate__animated animate__faster animate__fadeIn" ref={blur} onClick={e => closeHandler()}></div>
            <div className={`modal modal-alert animate__animated animate__faster ${alert.type === "danger" ? "animate__bounceIn" : "animate__zoomIn"}`} ref={modal}>
                <div className="modal-header">
                    <div className="title"></div>
                    <div className="close" onClick={e => closeHandler()}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#1E1F1F"/>
                            <path d="M15 25.8483L25.8483 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M25.8483 25.8483L15 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <div className="modal-icon">
                    {alert.type === "success" && (
                        <svg width="38" height="28" viewBox="0 0 38 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.646 14L13.2018 25.5559L36.3543 2.44421" stroke="#A8D81A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    )}

                    {alert.type === "danger" && (
                        <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M37.4443 60.5559L60.556 37.4442" stroke="#D81A1A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M60.556 60.5559L37.4443 37.4442" stroke="#D81A1A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    )}

                    {alert.type === "info" && (
                        <svg width="4" height="36" viewBox="0 0 4 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 1.66663V22.0833" stroke="#0F55D9" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1.97754 34.3334H2.01421" stroke="#0F55D9" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    )}
                </div>

                <div className="modal-alert-details">
                    <div className="title">{alert.title}</div>
                    <div className="text" dangerouslySetInnerHTML={{__html: alert.text}}></div>

                    {alert.moonpay && (
                        <div className="button blue" onClick={e => window.open(`https://www.moonpay.com/`, '_blank')}>Place a bet</div>
                    )}

                    {alert.cashapp && (
                        <div className="button blue" onClick={e => window.open(`https://t.me/casinos_support_bot`, '_blank')}>Contact support</div>
                    )}

                    <div className="button" style={{marginTop: 0}} onClick={e => closeHandler()}>{alert.button}</div>
                </div>
            </div>
        </>
    )    
}